<!-- https://xd.adobe.com/view/49c7325d-4e9a-44d9-b6f4-d9b577d64d3a-1c94/ -->
<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 mb2">
<template>
  <div class="col-12 px2" v-if="showMobile && haaID !== '0'">
    <div class="clearfix border muted-border p2 pb3 mb2 shadow">
      <div class="xs-col-12 sm-col-12 md-col-8 lg-col-10 p2">
        <p class="h5 semi-bold darkblue line-height-2 mt3 mb2 gibson">
          Redigér i din profil-side på Håndværker.dk
        </p>
        
        <p class="h5 regular darkblue line-height-golden gibson">
          Bekræft venligst din profilbeskrivelse nedenfor.
        </p>
      </div>
        <!-- TEXT -->
        <el-collapse v-model="activeName" v-b-toggle.profiletext class="col-12 px2 gibson mb2 border-collapse" accordion>
          <el-collapse-item name="2">
            <template slot="title">
              <div class="flex flex-column items-start">
                <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profiltekst</p>
                <p class="h5 regular darkblue line-height-golden gibson">
                  Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på
                  Google.
                </p>
              </div>
            </template>
            <div class="py1"></div>
            <div class=" flex col-12 justify-end p0 semi-bold ">
              <p class="darkblue m0">{{eliglbletextlimit}} Tekst</p>
            </div>
            <quill-editor ref="myQuillEditor" v-model="myHTML" :options="editorConfig" />
            <button class="action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson"
              @click="savetextConfirm()">
              <span class="semi-bold">Gem ændringer</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
          </el-collapse-item>
        </el-collapse>
    </div>
  </div>
  <div class="col-12 px2" v-if="!showMobile && haaId !== '0'">
    <div class="clearfix p2 pb3 mb2 ml4">
      <div class="col-12 p2">
        <div class="row">
          <div class="col-6">
            <p class="h4 semi-bold darkblue line-height-2 mt3 mb2 gibson">
              Redigér i din profil-side på Håndværker.dk
            </p>
          </div>
        </div>
        <p class="h5 regular darkblue line-height-golden gibson">
          Bekræft venligst din profilbeskrivelse nedenfor.
        </p>
        <!-- <p class="h5 regular darkblue line-height-golden gibson">
          Ville du vælge dig selv på baggrund af det, der vises på din profil i dag? Kan du præsenteres endnu bedre? Har du nye projekter du vil vise? Vi kan hjælpe dig i dag! Opdaterer du din profil eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i
          løbet af 24 timer.
        </p> -->
        <!-- <p class="h5 regular darkblue line-height-golden gibson">
          Opdaterer du din profil eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i løbet af 24 timer.
        </p> -->
      </div>
      <!-- TEXT -->
      <el-collapse v-model="activeName" v-b-toggle.profiletext  class="col-12 px2 gibson mb2 border-collapse" accordion>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="flex flex-column items-start">
              <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profiltekst</p>
              <p class="h5 regular darkblue line-height-golden gibson">
                Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på Google.
              </p>
            </div>
          </template>
          <div class="py1"></div>
            <div class=" flex col-12 justify-end p0 semi-bold ">
              <p class="darkblue m0">{{eliglbletextlimit}} Tekst</p>
            </div>
            <quill-editor ref="myQuillEditor" v-model="myHTML" :options="editorConfig" />
            <button class="action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson"
              @click="savetextConfirm()">
              <span class="semi-bold">Gem ændringer</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
  <!-- overlay for basis member -->
  <div class="clearfix relative gibson px2 mb2 hide">
    <div class="absolute left-0 right-0 top-0 bottom-0 transparent-darkblue-background white p4 col-12 flex flex-column justofy-center items-start z2">
      <div>
        <p class="h4 gibson regular white line-height-golden">Som basismedlem har du desværre ikke adgang til denne del af partner-login.<br>
          Opgrader din løsning, hvis du vil have adgang.
        </p>
        <button class="p2 my2 white-button flex justify-center items-center gibson h5 not-rounded border-none line-height-1">
          <span>Kontakt mig</span>
          <span class="mx2"><i class="el-icon-right"></i></span>
        </button>
      </div>
    </div>
  </div>
</template>
    </div>
<div ref="containerImg">
    </div>
<div class="py4"></div>
<loading :show="show" :label="label" :overlay="overlay"></loading>
<simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import profilsideinformation from './Profilsideinformation'
import ratingWidget from './ratingWidget'
import commentWidget from './commentWidget'
import imagefolder from './uploads/imagefolder'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import Slim from '../../slim/slim.module.js'
import VueQuillEditor from 'vue-quill-editor'
export default {
  name: 'ProfilSide',
  components: {
    ratingWidget,
    commentWidget,
    VueQuillEditor,
    Slim,
    profilsideinformation,
    imagefolder,
    loading,
    Simplert
  },
  data () {
    return {
      myHTML: '',
      ratingwidget: '',
      commentwidget: '',
      FileLocation: '',
      instance: null,
      show: false,
      modalShowBillede: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      options: {
        hideModules: { 'link': true, 'code': true, 'justifyRight': true, 'justifyCenter': true, 'table': true, 'italic': true }
      },
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        // The configuration of the editor.
      },
      content: `
        <h1 class="ql-align-center"><span class="ql-font-serif" style="background-color: rgb(240, 102, 102); color: rgb(255, 255, 255);"> I am snow example! </span></h1><p><br></p><p><span class="ql-font-serif">W Can a man still be brave if he's afraid? That is the only time a man can be brave. </span></p><p><br></p><p><strong class="ql-font-serif ql-size-large">Courage and folly is </strong><strong class="ql-font-serif ql-size-large" style="color: rgb(230, 0, 0);">always</strong><strong class="ql-font-serif ql-size-large"> just a fine line.</strong></p><p><br></p><p><u class="ql-font-serif">There is only one God, and his name is Death. And there is only one thing we say to Death: "Not today."</u></p><p><br></p><p><em class="ql-font-serif">Fear cuts deeper than swords.</em></p><p><br></p><pre class="ql-syntax" spellcheck="false"><span class="hljs-keyword">const</span> a = <span class="hljs-number">10</span>;
        <span class="hljs-keyword">const</span> editorOption = { <span class="hljs-attr">highlight</span>: <span class="hljs-function"><span class="hljs-params">text</span> =&gt;</span> hljs.highlightAuto(text).value };</pre><p><br></p><p><span class="ql-font-serif">Every flight begins with a fall.</span></p><p><br></p><p><a href="https://surmon.me/" rel="noopener noreferrer" target="_blank" class="ql-font-serif ql-size-small" style="color: rgb(230, 0, 0);"><u>A ruler who hides behind paid executioners soon forgets what death is. </u></a></p><p><br></p><iframe class="ql-video ql-align-center" frameborder="0" allowfullscreen="true" src="https://www.youtube.com/embed/QHH3iSeDBLo?showinfo=0" height="238" width="560"></iframe><p><br></p><p><span class="ql-font-serif">Hear my words, and bear witness to my vow. Night gathers, and now my watch begins. It shall not end until my death. I shall take no wife, hold no lands, father no children. I shall wear no crowns and win no glory. I shall live and die at my post. I am the sword in the darkness. I am the watcher on the walls. I am the fire that burns against the cold, the light that brings the dawn, the horn that wakes the sleepers, the shield that guards the realms of men. I pledge my life and honor to the Nightâs Watch, for this night and all the nights to come.</span></p><p><br></p><p><span class="ql-font-serif">We are born to suffer, to suffer can make us strong.</span></p><p><br></p><p><span class="ql-font-serif">The things we love destroy us every time.</span></p>
      `,
      slimOptions: {
        initialImage: this.FileLocation,
        service: this.slimService,
        didInit: this.slimInit,
        didConfirm: this.slimConfirm
      },
      haaId: '',
      imageId: '',
      items: [],
      videos: [],
      images: [],
      eligible: '',
      eliglbletextlimit: 'Ubegrænset',
      activeName: '2',
      salesPersonbitrix: '',
      spaId: '',
      profileText: '',
      spainfo: {}
    }
  },
  created () {
    this.eligible = localStorage.getItem('AccessVideoProProfile')
    this.tokenfordecode = this.$route.query.token
    this.decode(this.tokenfordecode)
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1300) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
    // this.Reload()
  },
  methods: {
    getdataigibility () {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'AccessVideoProProfile')
      } else {
        this.$refs.picDisplay.show = true
      }
    },
    slimInit (data, slim) {
      console.log(slim)
      console.log(data)
      this.instance.edit()
      this.show = false
    },
    openUrl () {
      var win = window.open(this.items.url, '_blank')
      win.focus()
    },
    slimConfirm (data, slim) {
      console.log()
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'edit_image', salesPerson: this.salesPerson, levid: this.haaId, imageId: this.imageId, image: this.instance.dataBase64.output.image}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.images = res.resultImages
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    // called when upload button is pressed or automatically if push is enabled s
    slimService (formdata, progress, success, failure, slim) {
      console.log(slim)
      // set serviceFormat to "file" to receive an array of files
      console.log(formdata)
      console.log(progress, success, failure)
    },
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res
            this.myHTML = res.Description
            this.images = res.resultImages
            this.videos = res.resultVideos
            this.ratingwidget = res.ratingwidget
            this.commentwidget = res.commentwidget
          },
          response => {
            alert('error')
          }
        )
    },
    SaveDescription () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'oversigt_partner_haa_desc', salesPerson: this.salesPerson, levid: this.haaId, description: this.myHTML}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.saveConfirmpermissionautomated()
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: 'Tak for opdateringen :)<br />' +
                  'Din tekst kommer online på din profil så snart den er godkendt.<br />' +
                  '<br />' +
                  'Hvis du har nogle spørgsmål, så ring eller skriv endelig.<br />',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    saveConfirmpermissionautomated () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      this.$http.post(this.$bitrixapi + 'external/AutomatedOnboardingApprovedByCraftman?LEV_ID=' + this.haaId, {headers}, { emulateJSON: true }).then(
        (response) => {
        },
        (response) => {
        }
      )
    },
    SaveProfile () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'oversigt_partner_haa_profile', salesPerson: this.salesPerson, levid: this.haaId, items: this.items}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    edit_image (FileLocation, imageId) {
      this.imageId = imageId
      FileLocation = FileLocation.split('?')
      if (this.instance) {
        this.show = true
        this.img.src = FileLocation[0]
        this.instance = new Slim(this.$refs.containerImg, this.slimOptions)
      } else {
        this.show = true
        this.FileLocation = FileLocation[0]
        this.img = document.createElement('img')
        this.img.setAttribute('alt', '')
        this.img.src = FileLocation[0]
        this.$refs.containerImg.appendChild(this.img)
        this.instance = new Slim(this.$refs.containerImg, this.slimOptions)
      }
    },
    delete_video (videoId) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'delete_video', salesPerson: this.salesPerson, levid: this.haaId, videoId: videoId}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            console.log('res', res)
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.videos = []
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    delete_image (imageId) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'delete_image', salesPerson: this.salesPerson, levid: this.haaId, imageId: imageId}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.images = res.resultImages
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    SaveImage (imageId, position) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'image_position', salesPerson: this.salesPerson, levid: this.haaId, imageId: imageId, position: position}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.images = res.resultImages
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    decodehtml (text) {
      let textArea = document.createElement('textarea')
      textArea.innerHTML = text
      return textArea.value
    },
    savetextConfirm () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        spaId: this.spaId,
        profileText: this.myHTML
      }
      this.$http.post(this.$bitrixapi + 'external/confirmProfileText', data, {headers}, { emulateJSON: true }).then(
        (response) => {
          let obj = {
            title: 'Gennemført!',
            message: 'Tak for opdateringen :)<br />' +
              'Din tekst kommer online på din profil så snart den er godkendt.<br />' +
              '<br />' +
              'Hvis du har nogle spørgsmål, så ring eller skriv endelig.<br />',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          setTimeout(() => {
            this.$router.push('/newsfeed')
          }, 2000)
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    getsupplieriblockinfo (id) {
      this.$http.get(this.$bitrixapi + 'external/getProfileText?spaId=' + id, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.profileText = res.data.PROFILE_TEXT
            this.myHTML = this.profileText
            this.spainfo = res.data
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    decode (token) {
      this.$http.get(this.$bitrixapi + 'helper/decode/' + token, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            // if (res.data === '') {
            //   this.showpopuperror()
            // }
            this.spaId = res.data
            if (this.spaId !== '') {
              this.getsupplieriblockinfo(this.spaId)
            }
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    }
  }
}
</script>
<style>
.el-collapse-item__header{
  height: 100% !important;
}
.border-collapse{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
</style>



// WEBPACK FOOTER //
// confirm-description.vue?8bb49922